import { checkCanUseWebP } from './checkCanUseWebP';

const canUseWebP = checkCanUseWebP();

export const getLargeThumbnailURL = (thumbnailURL, type) => {
  let sources = [];
  let img = {
    src: thumbnailURL,
    srcset: thumbnailURL,
  };
  let socialShare = thumbnailURL;
  if (thumbnailURL && thumbnailURL.endsWith('/')) {
    let ext = 'webp';
    if (!canUseWebP) {
      if (type === 'element' || type === 'designer-elements') {
        ext = 'png';
      } else {
        ext = 'jpeg';
      }
    }
    const parts = thumbnailURL.split('/');
    if (type === 'template') {
      sources = [
        {
          srcset: `${thumbnailURL}${parts[parts.length - 2]}-400.${ext}`,
          media: '(max-width: 600px)',
          key: 600,
        },
        {
          srcset: `${thumbnailURL}${parts[parts.length - 2]}-600.${ext}`,
          media: '(max-width: 900px)',
          key: 900,
        },
        {
          srcset: `${thumbnailURL}${parts[parts.length - 2]}-900.${ext}`,
          media: '(max-width: 1200px)',
          key: 1200,
        },
        {
          srcset: `${thumbnailURL}${parts[parts.length - 2]}-1200.${ext}`,
          media: '(max-width: 1500px)',
          key: 1500,
        },
        {
          srcset: `${thumbnailURL}${parts[parts.length - 2]}-1500.${ext}`,
          media: '(max-width: 2400px)',
          key: 1500,
        },
      ];
      img = {
        src: `${thumbnailURL}${parts[parts.length - 2]}-1500.${ext}`,
        srcset: `${thumbnailURL}${
          parts[parts.length - 2]
        }-1500.${ext} 1x, ${thumbnailURL}${
          parts[parts.length - 2]
        }-2400.${ext} 1.5x`,
      };
    } else {
      img = {
        src: `${thumbnailURL}${parts[parts.length - 2]}-1500.${ext}`,
        srcset: `${thumbnailURL}${parts[parts.length - 2]}-1500.${ext}`,
      };
    }
    socialShare = `${thumbnailURL}${parts[parts.length - 2]}-1500.${ext}`;
  }
  return {
    sources,
    img,
    socialShare,
  };
};
